import { BaseError } from './base-error';

export class ServerErrorShownError extends BaseError {}
